// extracted by mini-css-extract-plugin
export default {"container":"om-z","heading":"pm-z","text":"qm-z","info":"rm-z","link":"sm-z","fullMaxWidth":"tm-z"};